// =======================
// Stable Swiper for .product-media-swiper (bullets only)
// - No progress bar
// - No duplicate inits
// - No destroy/reinit during scroll (mobile address bar resize)
// =======================

(function () {
    'use strict';

    const swiperByEl = new WeakMap();
    let lastIsMobile = null; // 'true' when <= 749px

    // -------- Destroy (scoped) --------
    function destroySwiper(el) {
        const inst = swiperByEl.get(el);
        if (inst && typeof inst.destroy === 'function') {
            try { inst.destroy(true, true); } catch (e) { }
        }
        swiperByEl.delete(el);

        const pag = el.querySelector('.mobile-product-media-pagination');
        if (pag) pag.remove();
    }

    // -------- Init (scoped, bullets only) --------
    function initSwiper(el) {
        if (!el || swiperByEl.has(el)) return;

        if (!el.classList.contains('.product-media-swiper')) el.classList.add('swiper');

        let pag = el.querySelector('.mobile-product-media-pagination');
        if (!pag) {
            pag = document.createElement('div');
            pag.className = 'mobile-product-media-pagination';
            el.appendChild(pag);
        }

        const inst = new Swiper(el, {
            loop: false,
            slidesPerView: 1,
            spaceBetween: 10,
            observer: true,
            observeParents: true,
            resizeObserver: true,
            speed: 300,
            effect: 'slide',
            pagination: {
                el: pag,
                clickable: true,
                type: 'bullets',
                bulletClass: 'swiper-pagination-bullet',
                bulletActiveClass: 'swiper-pagination-bullet-active',
                renderBullet: function (index, className) {
                    return `<span class="${className}" data-index="${index}"></span>`;
                }
            },
            on: {
                init: function () {
                    pag.classList.remove('swiper-pagination-progressbar');
                    const fill = pag.querySelector('.swiper-pagination-progressbar-fill');
                    if (fill) fill.remove();

                    this.updatePaginationClasses = function () {
                        const bullets = Array.from(this.pagination.bullets || []);
                        const activeIndex = this.activeIndex;

                        bullets.forEach((bullet, index) => {
                            const distance = Math.abs(parseInt(bullet.getAttribute('data-index')) - activeIndex);
                            bullet.classList.remove('is-near-1', 'is-near-2');
                            if (distance === 1) bullet.classList.add('is-near-1');
                            else if (distance === 2) bullet.classList.add('is-near-2');
                        });
                    }.bind(this);

                    this.updatePaginationClasses();
                },
                slideChange: function () {
                    if (typeof this.updatePaginationClasses === 'function') {
                        this.updatePaginationClasses();
                    }
                },
                paginationUpdate: function () {
                    if (typeof this.updatePaginationClasses === 'function') {
                        this.updatePaginationClasses();
                    }
                }
            }
        });

        if (!document.getElementById('swiper-pagination-styles')) {
            const style = document.createElement('style');
            style.id = 'swiper-pagination-styles';
            style.textContent = `/* pagination styles */ 
          .mobile-product-media-pagination{position:absolute;display:flex;justify-content:left;align-items:center;margin-top:15px;padding:8px 10px;gap:6px;z-index:10}
          .swiper-pagination-bullet{width:6px;height:6px;border-radius:50%;background:rgba(0,0,0,.2);margin:0!important;transition:all .3s cubic-bezier(.4,0,.2,1);cursor:pointer;border:none;outline:none;padding:0;opacity:.6}
          .swiper-pagination-bullet-active{width:6px;height:6px;border-radius:9999px;background:#000;opacity:1}
          .swiper-pagination-bullet.is-near-1{width:6px;height:6px;opacity:.8}
          .swiper-pagination-bullet.is-near-2{width:6px;height:6px;opacity:.7}
          .swiper-pagination-bullet:hover{opacity:1;transform:scale(1.1)}
          .swiper-pagination-bullet-active:hover{transform:none}`;
            document.head.appendChild(style);
        }

        swiperByEl.set(el, inst);
    }

    // -------- Apply mode (mobile/desktop) only when breakpoint actually changes --------
    function initAllSwipers(force = false) {
        const isMobile = window.innerWidth <= 750;
        if (!force && lastIsMobile === isMobile) return;

        document.querySelectorAll('.product-media-swiper').forEach(el => {
            if (!el || !el.isConnected) return;
            if (isMobile) {
                destroySwiper(el);
                initSwiper(el);
            } else {
                destroySwiper(el);
            }
        });

        lastIsMobile = isMobile;
    }

    // -------- Variant logic --------
    function processVariantCustom() {
        var today = new Date();
        const infoWrapper = document.querySelector('.product__info-wrapper');
        if (!infoWrapper) return;

        // ✅ Get all fieldsets
        const fieldsets = document.querySelectorAll('fieldset');

        // ✅ Collect only one checked input per fieldset
        const selected_variant_values = Array.from(fieldsets).map(fs => {
            const checked = fs.querySelector('input:checked');
            return checked ? checked.value : null;
        }).filter(Boolean); // null hatane ke liye

        // ✅ Remove duplicates (if desktop/mobile dono inputs aaye)
        const unique_values = [...new Set(selected_variant_values)];

        // ✅ Join string
        const selected_variant = unique_values.join(" / ");
        const productWishlistbutton = infoWrapper.querySelector('.wishlist_button');



        if (!selected_variant) return;

        if (typeof p_variants !== 'undefined' && Array.isArray(p_variants)) {
            p_variants.forEach(i3 => {
                if (i3.title == selected_variant) {
                    if (productWishlistbutton) {
                        productWishlistbutton.setAttribute('data-product-variant-id', i3.id);
                        productWishlistbutton.setAttribute('data-selected-variant-value', i3.option1);
                    }
                    document.querySelectorAll('.stock-label').forEach(el => el.style.display = 'none');
                    // Show selected
                    const target = document.querySelector(`.stock-label[data-variant-id="${i3.id}"]`);
                    if (target) target.style.display = 'flex';

                    document.querySelectorAll('.estimated-delivery').forEach(el => el.style.display = 'none');
                    // Show selected
                    const dlivery_target = document.querySelector(`.estimated-delivery[data-variant-id="${i3.id}"]`);
                    if (dlivery_target) dlivery_target.style.display = 'block';

                    let variant_images = "";
                    if (i3.variant_image) {
                        const grid = document.querySelector(".product__media-list");
                        const gridImg = document.querySelector(".product__media-list img");
                        const swiper = document.querySelector(".product-media-swiper");
                        const swiperImg = document.querySelector(".product-media-swiper img");
                        if (grid) {
                            grid.style.transition = 'opacity 0.5s';
                            grid.offsetHeight; // reflow
                            grid.style.opacity = '0';
                            gridImg.style.transition = 'opacity 1s';
                            gridImg.offsetHeight; // reflow
                            gridImg.style.opacity = '0';
                        }
                        if (swiper) {
                            swiper.style.transition = 'opacity 0.5s';
                            swiper.offsetHeight; // reflow
                            swiper.style.opacity = '0';
                            swiperImg.style.transition = 'opacity 1s';
                            swiperImg.offsetHeight; // reflow
                            swiperImg.style.opacity = '0';
                        }

                        setTimeout(() => {
                            if (window.innerWidth <= 750) {
                                variant_images += '<div class="swiper-wrapper">';
                                i3.variant_image.forEach(media => {
                                    if (typeof media === "string") {
                                        variant_images += `
                                        <div class="swiper-slide product__media-item grid__item scroll-trigger animate--fade-in swiper-slide-active" role="group" aria-label="1 / 3" style="width: 345px; margin-right: 10px;">
          

                                        <div class="product-media-container media-type-image media-fit-fill global-media-settings gradient" style="--ratio: 0.8; --preview-ratio: 0.8;">
                                        <modal-opener class="product__modal-opener product__modal-opener--image" data-modal="#ProductModal-template--25018520174871__main">

                                        <div class="loading__spinner hidden">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg>

                                        </div>
                                        <div class="product__media media media--transparent">
                                            <img src="${media}" alt="" srcset="${media.replace(/width=\d+/g, 'width=246')} 246w, ${media.replace(/width=\d+/g, 'width=493')} 493w, ${media.replace(/width=\d+/g, 'width=600')} 600w, ${media.replace(/width=\d+/g, 'width=713')} 713w, ${media.replace(/width=\d+/g, 'width=823')} 823w, ${media.replace(/width=\d+/g, 'width=990')} 990w, ${media.replace(/width=\d+/g, 'width=1100')} 1100w, ${media.replace(/width=\d+/g, 'width=1206')} 1206w, ${media.replace(/width=\d+/g, 'width=1346')} 1346w, ${media.replace(/width=\d+/g, 'width=1426')} 1426w, ${media.replace(/width=\d+/g, 'width=1646')} 1646w, ${media.replace(/width=\d+/g, 'width=1946')} 1946w" width="1946" height="2433" loading="lazy" class="image-magnify-lightbox" sizes="(min-width: 1200px) 715px, (min-width: 990px) calc(65.0vw - 10rem), (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw / 1 - 4rem)">
                                            </div>
                                        </modal-opener></div>

                                                </div>`;
                                    } else if (media.media_type === "video" && media.sources) {
                                        variant_images += `<div class="swiper-slide">
                                        <div class="product-media-container product-media-container--video media-fit" style="--ratio: 0.8; --preview-ratio: 0.8;">
                                        <div class="product__media media media--transparent">
                                        <deferred-media><video autoplay loop muted playsinline>`;
                                        media.sources.forEach(source => {
                                            if (source.mime_type.includes("video")) {
                                                variant_images += `<source src="${source.url}" type="${source.mime_type}">`;
                                            }
                                        });
                                        variant_images += `Your browser does not support the video tag.</video></deferred-media></div></div></div>`;
                                    }
                                });
                                variant_images += "</div>";

                                document.querySelector("media-gallery").innerHTML = `<div class="product-media-swiper swiper">${variant_images}</div>`;

                                setTimeout(() => {
                                    initAllSwipers(true);
                                    const container = document.querySelector('.product-media-swiper');
                                    if (container) initCustomZoom(container);
                                }, 100);

                            } else {
                                variant_images = "";
                                i3.variant_image.forEach(media => {
                                    if (typeof media === "string") {

                                        variant_images += `
                      <li class="product__media-item grid__item slider__slide is-active scroll-trigger animate--fade-in" 
                            data-media-id="template--25018520174871__main-40888521785623">

                            <div class="product-media-container media-type-image media-fit-cover global-media-settings gradient constrain-height" style="--ratio: 0.8; --preview-ratio: 0.8;">
                            <modal-opener class="product__modal-opener product__modal-opener--image" data-modal="#ProductModal-template--25018520174871__main">
                                

                            <div class="loading__spinner hidden">
                            <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg>

                            </div>
                            <div class="product__media media media--transparent">
                                <img src="${media}?width=1946" alt="" srcset="${media}?width=246 246w, ${media}?width=493 493w, ${media}?width=600 600w, ${media}?width=713 713w, ${media}?width=823 823w, ${media}?width=990 990w, ${media}?width=1100 1100w, ${media}?width=1206 1206w, ${media}?width=1346 1346w, ${media}?width=1426 1426w, ${media}?width=1646 1646w, ${media}?width=1946 1946w" width="1946" height="2433" loading="lazy" class="image-magnify-lightbox" sizes="(min-width: 1200px) 715px, (min-width: 990px) calc(65.0vw - 10rem), (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw / 1 - 4rem)">
                                </div>
                            </modal-opener></div>

                                    </li>
                      `;
                                    } else if (media.media_type === "video" && media.sources) {
                                        variant_images += `
                                        <li  class="product__media-item grid__item slider__slide product__media-item--full scroll-trigger animate--fade-in">
                                        <div class="product-media-container media-type-video media-fit-cover global-media-settings gradient constrain-height" style="--ratio: 0.838; --preview-ratio: 0.8382352941176471;">
                                        <deferred-media class="deferred-media media media--transparent" data-media-id="39388036956458">
                                        <video autoplay loop muted playsinline>`;
                                        media.sources.forEach(source => {
                                            if (source.mime_type.includes("video")) {
                                                variant_images += `<source src="${source.url}" type="${source.mime_type}">`;
                                            }
                                        });
                                        variant_images += `</video></deferred-media></div></li>`;
                                    }
                                });
                                grid.innerHTML = variant_images;
                            }
                             if (grid){ 
                                grid.style.transition = 'opacity 0.5s';
                                grid.offsetHeight; // reflow
                                grid.style.opacity = '1';
                                gridImg.style.transition = 'opacity 1s';
                                gridImg.offsetHeight; // reflow
                                gridImg.style.opacity = '1';
                             }
                            if (swiper) {
                                swiper.style.transition = 'opacity 0.5s';
                                swiper.offsetHeight; // reflow
                                swiper.style.opacity = '1';
                                swiperImg.style.transition = 'opacity 1s';
                                swiperImg.offsetHeight; // reflow
                                swiperImg.style.opacity = '1';
                            }
                        }, 500);

                    } else {
                        const mobile_img = document.querySelector(".product-media-swiper .swiper-slide img");
                        const img = document.querySelector(".product__media-list li img");
                        const container = document.querySelector('.product-media-swiper');
                        if (img && mobile_img && container && i3.featured_image && i3.featured_image.src) {
                            const media = i3.featured_image.src;
                            const newSrc = media;
                            const newSrcset = `${media};width=300 300w,${media};width=450 450w,${media};width=600 600w,${media};width=750 750w,${media};width=900 900w`;
                            fadeOutIn(img, newSrc, newSrcset);
                            fadeOutIn(mobile_img, newSrc, newSrcset);
                        }
                        if (container) initCustomZoom(container);
                    }
                }
            });
        }
    }

    // -------- Fade helpers --------
    function fadeOutIn(el, newSrc, newSrcset) {
        el.style.transition = "opacity 0.2s";
        el.style.opacity = 0;
        setTimeout(() => {
            el.src = newSrc;
            if (newSrcset) el.srcset = newSrcset;
            el.style.transition = "opacity 0.4s";
            el.style.opacity = 1;
        }, 500);
    }


    // -------- Custom Zoom Functionality --------
    class CustomZoom {
        constructor() {
            this.dialog = null;
            this.currentIndex = 0;
            this.media = [];
            this.init();
        }

        init() {
            this.createDialog();
            this.setupEventListeners();
        }

        createDialog() {
            if (document.getElementById('custom-zoom-dialog')) return;

            // Add styles if they don't exist
            if (!document.getElementById('custom-zoom-styles')) {
                const style = document.createElement('style');
                style.id = 'custom-zoom-styles';
                style.textContent = `
          #custom-zoom-dialog {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0,0,0,0.9);
            z-index: 1000;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          #custom-zoom-dialog[hidden] {
            display: none !important;
          }
          .dialog-zoomed-gallery__content {
            display: flex;
            overflow-x: auto;
            width: 100%;
            height: 100%;
            scroll-snap-type: x mandatory;
            scroll-behavior: smooth;
            align-items: center;
            max-width: 1000px;
            margin: 0 auto;
          }
            .dialog-zoomed-gallery__content .product-media-container{
                flex: 0 0 100%;
                scroll-snap-align: start;
                position: relative;
            }
            .product-media-container--image img,
            .product-media-container--video video{
                max-width: 100%;
                width: 100%;
            }
          .dialog-zoomed-gallery__close-button {
            position: absolute;
            top: 20px;
            right: 20px;
            background: rgba(0,0,0,0.5);
            border: none;
            color: white;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            z-index: 1001;
            min-width: auto !important;
            min-height: auto !important;
            padding: 0 !important;
          }
            .dialog-zoomed-gallery__close-button:after,
            .dialog-zoomed-gallery__close-button:before {
                display: none !important;
            }
          .dialog-thumbnails-list-container {
            position: absolute;
            bottom: 20px;
            left: 0;
            right: 0;
            display: flex;
            justify-content: center;
            z-index: 1001;
          }
          .dialog-thumbnails-list {
            display: flex;
            gap: 10px;
            padding: 10px;
            background: rgba(0,0,0,0.5);
            border-radius: 20px;
            max-width: 90%;
            overflow-x: auto;
          }
          .dialog-thumbnails-list button {
            width: 60px;
            height: 60px;
            border: 2px solid transparent;
            border-radius: 4px;
            padding: 0;
            background: none;
            cursor: pointer;
          }
          .dialog-thumbnails-list button[aria-selected="true"],
          .dialog-thumbnails-list button.is-active {
            border-color: #fff;
          }
          .dialog-thumbnails-list img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        `;
                document.head.appendChild(style);
            }

            const dialogHTML = `
        <div id="custom-zoom-dialog" class="dialog-zoomed-gallery" hidden>
          <button type="button" class="button button-unstyled dialog-zoomed-gallery__close-button" aria-label="Close">
            <span class="visually-hidden">Close</span>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2L2 12" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"></path>
              <path d="M12 12L2 2" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </button>
          <div class="dialog-thumbnails-list-container">
            <div class="dialog-thumbnails-list list-unstyled" ref="thumbnails"></div>
          </div>
          <div class="dialog-zoomed-gallery__content"></div>
        </div>
      `;

            document.body.insertAdjacentHTML('beforeend', dialogHTML);
            this.dialog = document.getElementById('custom-zoom-dialog');
            this.thumbnails = this.dialog.querySelector('[ref="thumbnails"]');
            this.content = this.dialog.querySelector('.dialog-zoomed-gallery__content');
        }

        setupEventListeners() {
            // Close on overlay click
            this.dialog.addEventListener('click', (e) => {
                if (e.target === this.dialog) this.close();
            });

            // Close on escape key
            document.addEventListener('keydown', (e) => {
                if (e.key === 'Escape' && !this.dialog.hidden) this.close();
            });

            // Close button
            const closeBtn = this.dialog.querySelector('.dialog-zoomed-gallery__close-button');
            if (closeBtn) {
                closeBtn.addEventListener('click', () => this.close());
            }
        }

        open(index, mediaArray) {
            if (!mediaArray || !mediaArray.length) {
                console.error('No media array provided or empty');
                return;
            }

            this.media = mediaArray;
            this.currentIndex = index;

            // Ensure dialog is created
            if (!this.dialog) {
                this.createDialog();
            }

            if (!this.dialog) {
                return;
            }

            this.updateDialog();

            // Show the dialog
            this.dialog.hidden = false;
            this.dialog.style.display = 'block';
            document.body.style.overflow = 'hidden';

            // Scroll to current image
            this.scrollToCurrent();
        }

        close() {
            if (!this.dialog) return;

            this.dialog.hidden = true;
            this.dialog.style.display = 'none';
            document.body.style.overflow = '';
        }

        updateDialog() {
            // Clear existing content
            this.content.innerHTML = '';
            this.thumbnails.innerHTML = '';

            // Add media items
            this.media.forEach((media, index) => {
                // Main content
                const mediaEl = this.createMediaElement(media, index);
                this.content.appendChild(mediaEl);

                // Thumbnails
                const thumb = this.createThumbnail(media, index);
                this.thumbnails.appendChild(thumb);
            });
        }

        createMediaElement(media, index) {
            const container = document.createElement('div');
            container.className = 'product-media-container product-media-container--image';
            container.dataset.index = index;

            if (media.media_type === 'image') {
                const img = document.createElement('img');
                img.src = this.getImageUrl(media, '2000x');
                img.alt = media.alt || 'Product image';
                img.loading = 'eager';
                container.appendChild(img);
            }
            // Add other media types (video, model) as needed

            return container;
        }

        createThumbnail(media, index) {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'button button-unstyled dialog-thumbnails-list__thumbnail';
            button.dataset.index = index;
            button.setAttribute('aria-label', `View image ${index + 1} of ${this.media.length}`);
            button.setAttribute('aria-selected', index === this.currentIndex);

            const img = document.createElement('img');
            img.src = this.getImageUrl(media, '100x');
            img.alt = '';
            img.loading = 'lazy';

            button.appendChild(img);
            button.addEventListener('click', (e) => this.onThumbnailClick(e, index));

            return button;
        }

        getImageUrl(media, size) {
            if (!media) return '';

            // If media has a src property, use it
            let src = media.src || '';

            // If no src but has preview_image, use that
            if (!src && media.preview_image) {
                src = media.preview_image.src || '';
            }

            // If still no src, return empty string
            if (!src) return '';

            // Remove any existing size parameters
            src = src.split('?')[0];

            // If it's a Shopify CDN URL, handle it specially
            if (src.includes('cdn.shopify.com')) {
                // Remove any existing size parameters from the filename
                src = src.replace(/_\d+x\d+(?=\.[a-z]{3,4}$)/i, '');
                src = src.replace(/(_\d+x)?(\.(jpg|jpeg|png|gif))$/i, '$2');

                // Add the new size parameter
                const separator = src.includes('?') ? '&' : '?';
                return `${src}${separator}width=${size}`;
            }

            // For non-Shopify URLs, just return the original src
            return src;
        }

        onThumbnailClick(e, index) {
            e.preventDefault();
            this.currentIndex = index;
            this.scrollToCurrent();
            this.updateActiveThumbnail();
        }

        scrollToCurrent() {
            const currentMedia = this.content.querySelector(`[data-index="${this.currentIndex}"]`);
            if (currentMedia) {
                currentMedia.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
            }
        }

        updateActiveThumbnail() {
            const thumbs = this.thumbnails.querySelectorAll('button');
            thumbs.forEach((thumb, index) => {
                const isSelected = index === this.currentIndex;
                thumb.setAttribute('aria-selected', isSelected);
                thumb.classList.toggle('is-active', isSelected);
            });
        }
    }

    // Initialize custom zoom
    const customZoom = new CustomZoom();

    // Initialize zoom buttons on a container
    function initCustomZoom(container) {
        if (!container) return;

        // Remove any existing zoom buttons first
        container.querySelectorAll('.custom-zoom-button').forEach(btn => btn.remove());

        // Find all image containers
        const images = container.querySelectorAll('.product__media.media.media--transparent');

        images.forEach((imgContainer) => {
            const imgElement = imgContainer.querySelector('img');
            if (!imgElement) return;

            // Make the image clickable
            imgElement.style.cursor = 'zoom-in';
            imgElement.addEventListener('click', function (e) {
                openZoomDialog(imgContainer, container);
            });

            // Rest of the existing zoom button code...
            if (imgContainer.querySelector('.custom-zoom-button')) return;

            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'button button-unstyled product-media-container__zoom-button custom-zoom-button';
            button.setAttribute('aria-label', 'Zoom image');
            button.innerHTML = `
        <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" style="width:16px;height:16px">
          <path d="M13,27A12,12,0,1,1,25,15,12,12,0,0,1,13,27ZM13,5A10,10,0,1,0,23,15,10,10,0,0,0,13,5Z" fill="currentColor"/>
          <path d="M30,29a1,1,0,0,1-.6-.2l-8-6a1,1,0,0,1,1.2-1.6l8,6a1,1,0,0,1,.2,1.4A1,1,0,0,1,30,29Z" fill="currentColor"/>
          <rect x="9" y="14" width="8" height="2" fill="currentColor"/>
          <rect x="12" y="11" width="2" height="8" fill="currentColor"/>
        </svg>
      `;

            // Add button styles
            Object.assign(button.style, {
                display: 'none',
                position: 'absolute',
                top: 'auto',
                bottom: '10px',
                right: '10px',
                zIndex: '10',
                background: 'rgba(255,255,255,0.9)',
                border: 'none',
                borderRadius: '50%',
                width: '25px',
                height: '25px',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                padding: '0',
                margin: '0',
                outline: 'none',
            });

            // Ensure container has relative positioning
            if (window.getComputedStyle(imgContainer).position === 'static') {
                imgContainer.style.position = 'relative';
            }

            imgContainer.appendChild(button);
        });

        // Add event delegation for zoom buttons and images
        container.addEventListener('click', function (e) {
            const zoomBtn = e.target.closest('.custom-zoom-button');
            const imgContainer = e.target.closest('.product__media.media');

            if (zoomBtn || (imgContainer && e.target.tagName === 'IMG')) {
                e.preventDefault();
                e.stopPropagation();

                const targetContainer = zoomBtn ? zoomBtn.closest('.product__media.media') : imgContainer;
                openZoomDialog(targetContainer, container);
            }
        });
    }

    // Helper function to open zoom dialog
    function openZoomDialog(imgContainer, container) {
        if (!imgContainer) return;

        const allImages = container.querySelectorAll('.product__media.media');
        const currentIndex = Array.from(allImages).indexOf(imgContainer);

        const mediaArray = [];
        allImages.forEach((img) => {
            const imgEl = img.querySelector('img');
            if (imgEl && imgEl.src) {
                mediaArray.push({
                    media_type: 'image',
                    src: imgEl.src.split('?')[0], // Remove any query parameters
                    alt: imgEl.alt || ''
                });
            }
        });

        if (mediaArray.length > 0) {
            customZoom.open(currentIndex, mediaArray);
        }
    }

    // -------- Init on DOM --------
    document.addEventListener('DOMContentLoaded', () => {
        const container = document.querySelector('.product-media-swiper, .product__media-list');
        if (container) initCustomZoom(container);
    });

    const originalProcessVariantCustom = processVariantCustom;
    window.processVariantCustom = function () {
        originalProcessVariantCustom.apply(this, arguments);
        setTimeout(() => {
            const container = document.querySelector('.product-media-swiper, .product__media-list');
            if (container) initCustomZoom(container);
        }, 100);
    };

    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            const container = document.querySelector('.product-media-swiper, .product__media-list');
            if (container) initCustomZoom(container);
        }, 500);
    });

    // -------- Boot --------
    initAllSwipers(true);

    const mql = window.matchMedia('(max-width: 750px)');
    if (mql.addEventListener) {
        mql.addEventListener('change', () => initAllSwipers());
    } else {
        mql.addListener(() => initAllSwipers());
    }

    // Variant change (delegated)
    document.addEventListener("change", e => {
        if (e.target.matches(".product__info-wrapper fieldset input[type='radio']")) {
            setTimeout(processVariantCustom, 500);
        }
    });

    processVariantCustom();
})();
